import {computed, inject, Injectable, signal} from '@angular/core';
import {LocalStorageService} from './storage.service';
import {ApiAppService} from '@kilobytelab/domain';
import {Circular} from '@kilobytelab/types';
import {AppService} from './app.service';

@Injectable({
  providedIn: 'root'
})
export class CircularesService {

  private appService = inject(AppService);
  private localstorage = inject(LocalStorageService);
  private apiApp = inject(ApiAppService);

  CIRCULARES = signal<(Circular & {color?: string, titulo?: string, icono?: string})[]>([]);

  circularesDisponibles = computed<boolean>(() => this.CIRCULARES().some(c => !c.estado));

  async checkCirculares() {
    const alumnos = this.appService.PADRE();
    if (!alumnos?.length) {
      this.CIRCULARES.set([]);
      await this.localstorage.setStateCirculares([]);
      return
    }
    const aulasUnicas = new Set(
      alumnos
        .filter(alumno => alumno.estado === 'alta' && alumno.aula > 0)
        .map(alumno => alumno.aula)
    );
    const aulas = Array.from(aulasUnicas);
    if (!aulas.length) {
      this.CIRCULARES.set([]);
      await this.localstorage.setStateCirculares([]);
      return
    }
    try {
      const [circulares, guardadas] = await Promise.all([
        this.apiApp.getCirculares(aulas),
        this.localstorage.getStateCirculares()
      ]);
      await this.updateCirculares(circulares, guardadas || []);
    } catch (err) {
      const guardadas: Circular[] = await this.localstorage.getStateCirculares();
      if (!guardadas) {
        throw new Error('Error recuperando las circulares')
      }
      this.CIRCULARES.set(guardadas)
    }
  }

  private async updateCirculares(circulares: Circular[], guardadas: Circular[]) {
    if (!guardadas.length) {
      const iniciales: Circular[] = circulares.map(c => ({...c, estado: false}));
      this.CIRCULARES.set(iniciales);
      await this.localstorage.setStateCirculares(iniciales);
      return
    }
    const diccionarioGuardadas = new Map(
      guardadas.map(g => [`${g.aula}-${g.fecha}`, g])
    );
    const fusionadas: Circular[] = circulares.map(nueva => {
      const clave = `${nueva.aula}-${nueva.fecha}`;
      const guardada = diccionarioGuardadas.get(clave);
      return {
        ...nueva,
        estado: guardada ? guardada.estado : false
      }
    });
    this.CIRCULARES.set(fusionadas);
    await this.localstorage.setStateCirculares(fusionadas)
  }

}